import { HorizontalView } from "_components/Abstractions/HorizontalView";
import { FormControl } from "_components/Forms/FormControl";
import { useFormContext } from "react-hook-form";
import { DomainButton } from "../../../../_components/Abstractions/DomainButton";
import { ExternalWeighingContractorSelect } from "./ExternalWeighingContractorSelect";

export function ContractorIntegrationDetailsForm() {
  const { watch, setValue, unregister } = useFormContext();
  const externalWeighingData = watch("externalWeighingData");

  const setValueOptions = {
    shouldValidate: true,
    shouldDirty: true,
    shouldTouch: true
  };

  const onExternalWeighingContractorSelect = (contractor) => {
    setValue(
      "externalWeighingData",
      { id: contractor.externalContractorId?.toString(), name: contractor.name1 },
      setValueOptions
    );
  };

  const removeExternalWeighingLink = () => {
    unregister("externalWeighingData.name");
    unregister("externalWeighingData.id");
    setValue("externalWeighingData", null, setValueOptions);
  };

  return (
    <div>
      <div className="mb-2">
        <ExternalWeighingContractorSelect onSelect={onExternalWeighingContractorSelect}/>
        {externalWeighingData && (
          <DomainButton className="ms-2 align-self-center" variant="secondary" onClick={removeExternalWeighingLink}>
            Usuń powiązanie z programem wagowym
          </DomainButton>
        )}
      </div>
      <HorizontalView>
        {externalWeighingData && (
          <FormControl label="Program wagowy" name="externalWeighingData.name" required={false} readonly/>
        )}
        <FormControl label="Program magazynowy" name="externalName" required={false}/>
      </HorizontalView>
    </div>
  );
}
